/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PxInputs */

const en_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const es_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const fr_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const de_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const ja_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const zh_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const ar_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بكسل`)
};

const id_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const it_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const ru_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`пикс.`)
};

const pt_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

const ko_px = /** @type {(inputs: PxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`px`)
};

/**
* | output |
* | --- |
* | "px" |
*
* @param {PxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const px = /** @type {((inputs?: PxInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PxInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_px(inputs)
	if (locale === "es") return es_px(inputs)
	if (locale === "fr") return fr_px(inputs)
	if (locale === "de") return de_px(inputs)
	if (locale === "ja") return ja_px(inputs)
	if (locale === "zh") return zh_px(inputs)
	if (locale === "ar") return ar_px(inputs)
	if (locale === "id") return id_px(inputs)
	if (locale === "it") return it_px(inputs)
	if (locale === "ru") return ru_px(inputs)
	if (locale === "pt") return pt_px(inputs)
	return ko_px(inputs)
});